import { LAST_MONTH } from '../components/generic/date-range-picker/date-range-picker.vue';

export default {
    namespaced: true,
    state() {
        return {
            dateRange: {
                name: LAST_MONTH,
            },
            groupingType: 0,
        };
    },
    getters: {
        dateRange: state => ({
            name: state.dateRange.name,
            from: new Date(parseInt(state.dateRange.from)),
            to: new Date(parseInt(state.dateRange.to)),
        }),
        groupingType: state => state.groupingType,
    },
    mutations: {
        setDateRange(state, range) {
            if (range && range.name && range.from && range.to) {
                state.dateRange = {
                    name: range.name,
                    // + converts dates to timestamps
                    from: +range.from,
                    to: +range.to,
                };
            }
        },
        setGroupingType(state, groupingType) {
            state.groupingType = groupingType;
        },
    },
    actions: {
        async changeDateRange({ commit }, value) {
            commit('setDateRange', value);
        },
        async changeGroupingType({ commit }, value) {
            commit('setGroupingType', value);
        },
    },
};
